import SVG from 'react-inlinesvg';

export const HeaderWithIcon: React.FC<{ icon: string; label: string }> = ({ icon, label }) => {
  return (
    <div className="flex items-center gap-2 px-2">
      <SVG src={icon} className="w-4 h-4" />
      <span className="sub-header-base text-neutral-950">{label}</span>
    </div>
  );
};

export const SeparatorHeader: React.FC = () => {
  return <div className="bg-neutral-300 w-1 min-w-1 max-w-1 p-0 m-0 box-border h-full" />;
};
